/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The type of ingestion source
*/
export enum IngestionSourceType {
  INGESTION_SOURCE_TYPE_S3 = 'S3'
}
